import React from "react";
//#region types
import { ChartEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ToggleButtonGroup from "../buttons/toggleButtonGroup";
import useChartContext from "./context/useContext";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ChartFrequencySelector: React.FC = (props) => {
  const chartContext = useChartContext();

  const onButtonClick = (frequency: ChartEnums.ChartDataFrequency) => {
    chartContext?.setChartFilter({ ...chartContext.filter, frequency });
  };

  return (
    <ToggleButtonGroup
      initialSelectionKey={chartContext?.filter.frequency}
      buttons={[
        {
          buttonKey: ChartEnums.ChartDataFrequency.Daily,
          children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Frequency_Daily),
          onClick: () => onButtonClick(ChartEnums.ChartDataFrequency.Daily),
        },
        {
          buttonKey: ChartEnums.ChartDataFrequency.Monthly,
          children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Frequency_Monthly),
          onClick: () => onButtonClick(ChartEnums.ChartDataFrequency.Monthly),
        },
        {
          buttonKey: ChartEnums.ChartDataFrequency.Quarterly,
          children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Frequency_Quarterly),
          onClick: () => onButtonClick(ChartEnums.ChartDataFrequency.Quarterly),
        },
        {
          buttonKey: ChartEnums.ChartDataFrequency.Yearly,
          children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Frequency_Yearly),
          onClick: () => onButtonClick(ChartEnums.ChartDataFrequency.Yearly),
        },
      ]}
    />
  );
};

export default ChartFrequencySelector;
